import { render, staticRenderFns } from "./WField.vue?vue&type=template&id=5781a04a&scoped=true&lang=pug&"
import script from "./WField.vue?vue&type=script&lang=js&"
export * from "./WField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5781a04a",
  null
  
)

export default component.exports